import React, { useState } from 'react';
import axios from 'axios';
import FormProposta from './FormProposta';
import ResultadoProposta from './ResultadoProposta';
import { cidades, tiposTelha } from './dadosProposta';

const API_URL =
  process.env.NODE_ENV === 'production'
    ? '' // Em produção, usa endpoint relativo
    : process.env.REACT_APP_API_URL || '/proposta';

function getConsultorFromURL() {
  const params = new URLSearchParams(window.location.search);
  const consultor = params.get('consultor');
  if (consultor) {
    return consultor.replace(/_/g, ' ');
  }
  return 'Consultor';
}

function App() {
  const TRANSITION_DURATION = 800; // ms

  const [formData, setFormData] = useState({
    cliente_nome: '',
    rua_numero: '',
    energia: '',
    cidade: cidades[0],
    cliente_cpf_cnpj: '',
    tipo_telha: tiposTelha[0],
  });
  const [result, setResult] = useState(null);
  const [showResumo, setShowResumo] = useState(false);

  const consultorNome = getConsultorFromURL();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/proposta?consultor=${encodeURIComponent(consultorNome)}`, {
        ...formData,
        energia: Number(formData.energia),
      });
      setResult(response.data);
      setShowResumo(true); // Mostra o resumo
    } catch (error) {
      alert('Erro ao calcular proposta. Verifique os dados.');
    }
  };

  // Função para baixar o PDF
  const handleDownloadPDF = () => {
    // Cria um formulário invisível
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${API_URL}/proposta/pdf?consultor=${encodeURIComponent(consultorNome)}`;
    form.style.display = 'none';

    // Adiciona os campos do formData como inputs
    Object.entries({
      ...formData,
      energia: Number(formData.energia),
    }).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

  // Função para visualizar o PDF em nova aba
  const handleVisualizarPDF = () => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `/proposta/pdf?consultor=${encodeURIComponent(formData.consultor || '')}&visualizar=1`;
    form.target = '_blank';
    form.style.display = 'none';

    Object.entries({
      ...formData,
      energia: Number(formData.energia),
    }).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

  const handleEditar = () => {
    setShowResumo(false);
  };

  return (
    <div
      className='app-container'
      style={{
        minHeight: '100vh',
        background: '#505050ff', // fundo da página cinza claro
        padding: '32px 0',
      }}
    >
      <div
        className='shadow p-4 rounded'
        style={{
          width: '100%',
          maxWidth: 370,
          margin: '8px auto',
          boxSizing: 'border-box',
          background: '#1a1a1a',
          color: '#fff',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            transition: `transform ${TRANSITION_DURATION}ms, opacity ${TRANSITION_DURATION}ms`,
            transform: showResumo ? 'translateY(-40px)' : 'translateY(0)',
            opacity: showResumo ? 0 : 1,
            position: showResumo ? 'absolute' : 'static',
            width: '100%',
            left: 0,
            top: 0,
            zIndex: showResumo ? 1 : 'auto',
          }}
        >
          {!showResumo && (
            <>
              <h1 className='text-center mb-2' style={{ fontSize: 24, color: '#ffbd00' }}>
                Proposta Grupo R
              </h1>
              <div className='text-center mb-4' style={{ fontSize: 18 }}>
                Seja bem vindo {consultorNome}!
              </div>
              <FormProposta formData={formData} onChange={handleChange} onSubmit={handleSubmit} />
            </>
          )}
        </div>
        <div
          style={{
            transition: `transform ${TRANSITION_DURATION}ms, opacity ${TRANSITION_DURATION}ms`,
            transform: showResumo ? 'translateY(0)' : 'translateY(40px)',
            opacity: showResumo ? 1 : 0,
            position: !showResumo ? 'absolute' : 'static',
            width: '100%',
            left: 0,
            top: 0,
            zIndex: !showResumo ? 1 : 'auto',
          }}
        >
          {showResumo && (
            <>
              <h1 className='text-center mb-2' style={{ fontSize: 24, color: '#ffbd00' }}>
                Resumo da Proposta
              </h1>
              <ResultadoProposta
                result={result}
                formData={formData}
                onDownloadPDF={handleDownloadPDF}
                onVisualizarPDF={handleVisualizarPDF}
                onEditar={handleEditar}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
